import { handleActions } from 'redux-actions';
import Immutable from 'immutable';
import { types as mainActionTypes } from 'actions/mainActions/mainActions';
import { types as apiActionTypes } from 'actions/apiActions/apiActions';

export const initialState = Immutable.fromJS({
  queryText: '',
  isLoading: false,
  isUserLoggedIn: false,
  authAccessToken: null,
  authRefreshToken: null,
});

export default handleActions({
  [mainActionTypes.START_LOADING]: (state) =>
    state.merge({ isLoading: true }),
  [mainActionTypes.STOP_LOADING]: (state) =>
    state.merge({ isLoading: false }),
  [mainActionTypes.SET_CHARITY]: (state, action) =>
    state.merge({ charityId: action.charityId }),
  [mainActionTypes.RESET_CHARITY_SELECTION]: (state) =>
    state.merge({ charityId: null }),
  [mainActionTypes.UPDATE_QUERY_TEXT]: (state, action) =>
    state.merge({ queryText: action.queryText }),
  [mainActionTypes.CLEAR_QUERY_TEXT]: (state) =>
    state.merge({ queryText: '' }),
  [mainActionTypes.UPDATE_IS_USER_LOGGED_IN]: (state, action) => state.set('isUserLoggedIn', action.isUserLoggedIn),

  [apiActionTypes.GET_PARTICIPANT_SUCCESS]: (state, action) => {
    let newState = state;

    if (action.response && action.response.charitySearchEnabled === false && action.response.charities && action.response.charities.length === 1) {
      newState = newState.merge({ charityId: String(action.response.charities[0].charityId) });
    }

    return newState;
  },
  [mainActionTypes.UPDATE_AUTH_ACCESS_TOKEN]: (state, action) => state.set('authAccessToken', action.accessToken),
  [mainActionTypes.UPDATE_AUTH_REFRESH_TOKEN]: (state, action) => state.set('authRefreshToken', action.refreshToken),
  [mainActionTypes.PARTICIPANT_PROMISE]: (state, action) => state.set('participantPromise', action.participantPromise),
  [mainActionTypes.PARTICIPANT_REQUEST_ERROR]: (state, action) => state.set('participantRequestError', action.participantRequestError),
  [mainActionTypes.RESET_PROCEED_TO_DONATION_CLICKED]: (state) => state.set('proceedToDonationClicked', false),
  [mainActionTypes.PROCEED_TO_DONATION_CLICKED]: (state) => state.set('proceedToDonationClicked', true),
}, initialState);



// WEBPACK FOOTER //
// ./reducers/mainReducers/mainReducers.js